/* AFROZ theme scripts */
(function(){
'use strict';
var AF = window.AF = window.AF || {};
var $ = function(s, c){ return (c || document).querySelector(s); };
var $$ = function(s, c){ return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

/* ---------- money ---------- */
AF.money = function(cents, fmt){
  fmt = fmt || window.afMoneyFormat || 'Rs.{{amount}}';
  if (typeof cents === 'string') cents = cents.replace('.', '');
  cents = parseInt(cents, 10) || 0;
  function fmtNum(n, prec, th, dec){
    th = th || ','; dec = dec || '.';
    var s = (n / 100).toFixed(prec);
    var parts = s.split('.');
    parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + th);
    return parts[1] ? parts[0] + dec + parts[1] : parts[0];
  }
  return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function(m, k){
    switch(k){
      case 'amount': return fmtNum(cents, 2);
      case 'amount_no_decimals': return fmtNum(cents, 0);
      case 'amount_with_comma_separator': return fmtNum(cents, 2, '.', ',');
      case 'amount_no_decimals_with_comma_separator': return fmtNum(cents, 0, '.', ',');
      case 'amount_with_apostrophe_separator': return fmtNum(cents, 2, "'", '.');
      default: return fmtNum(cents, 2);
    }
  });
};
function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
function imgUrl(src, w){ if(!src) return ''; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

/* ---------- toast ---------- */
AF.toast = function(msg){
  var t = $('.af-toast');
  if(!t){ t = document.createElement('div'); t.className = 'af-toast'; t.setAttribute('role','status'); t.setAttribute('aria-live','polite'); document.body.appendChild(t); }
  t.textContent = msg; t.classList.add('is-open');
  clearTimeout(t._t); t._t = setTimeout(function(){ t.classList.remove('is-open'); }, 2600);
};

/* ---------- panels (drawers, search) ---------- */
var overlay;
function getOverlay(){
  if(!overlay){ overlay = $('.af-overlay'); if(!overlay){ overlay = document.createElement('div'); overlay.className = 'af-overlay'; document.body.appendChild(overlay); } overlay.addEventListener('click', AF.closeAll); }
  return overlay;
}
var lastFocus = null;
AF.open = function(id){
  var el = document.getElementById(id); if(!el) return;
  AF.closeAll(true);
  lastFocus = document.activeElement;
  el.classList.add('is-open'); el.setAttribute('aria-hidden','false');
  getOverlay().classList.add('is-open');
  document.documentElement.style.overflow = 'hidden';
  var f = el.querySelector('input[type=search], .af-close, button, a'); if(f) setTimeout(function(){ f.focus(); }, 60);
  $$('[aria-controls="'+id+'"]').forEach(function(b){ b.setAttribute('aria-expanded','true'); });
};
AF.closeAll = function(silent){
  $$('.af-drawer.is-open, .af-search.is-open, .af-facets.is-open').forEach(function(el){ el.classList.remove('is-open'); el.setAttribute('aria-hidden','true'); $$('[aria-controls="'+el.id+'"]').forEach(function(b){ b.setAttribute('aria-expanded','false'); }); });
  if(overlay) overlay.classList.remove('is-open');
  document.documentElement.style.overflow = '';
  if(silent !== true && lastFocus && lastFocus.focus) lastFocus.focus();
};
document.addEventListener('click', function(e){
  var o = e.target.closest('[data-af-open]');
  if(o){ e.preventDefault(); if(o.getAttribute('data-af-open') === 'af-cart-drawer') AF.refreshCart(true); else AF.open(o.getAttribute('data-af-open')); return; }
  if(e.target.closest('[data-af-close]')){ e.preventDefault(); AF.closeAll(); }
});
document.addEventListener('keydown', function(e){ if(e.key === 'Escape'){ AF.closeAll(); var lb = $('.af-lightbox.is-open'); if(lb) lb.classList.remove('is-open'); } });

/* ---------- cart ---------- */
AF.cfg = function(){ return window.afCart || { threshold: 0, drawer: true }; };
AF.updateCount = function(n){ $$('[data-af-cart-count]').forEach(function(el){ el.textContent = n; el.setAttribute('data-count', n); }); };
AF.renderCart = function(cart){
  AF.updateCount(cart.item_count);
  var body = $('#af-cart-body'), foot = $('#af-cart-foot'); if(!body) return;
  var title = $('#af-cart-title-count'); if(title) title.textContent = '(' + cart.item_count + ')';
  if(!cart.item_count){
    body.innerHTML = '<div class="af-cart-empty"><p>Your bag is empty</p><a class="af-btn" href="' + root + 'collections/all">Continue shopping</a></div>';
    if(foot) foot.hidden = true; return;
  }
  var th = AF.cfg().threshold * 100, prog = '';
  if(th > 0){
    var left = th - cart.total_price, pct = Math.min(100, cart.total_price / th * 100);
    prog = '<div class="af-progress">' + (left > 0 ? 'You are <strong>' + AF.money(left) + '</strong> away from free shipping' : 'Lovely — you have unlocked <strong>free shipping</strong>') + '<div class="af-progress__bar"><span style="width:' + pct + '%"></span></div></div>';
  }
  body.innerHTML = prog + cart.items.map(function(it, i){
    var compare = it.original_line_price > it.final_line_price ? '<s>' + AF.money(it.original_line_price) + '</s>' : '';
    return '<div class="af-cart-item" data-key="' + esc(it.key) + '">' +
      '<a href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(imgUrl(it.image, 200)) + '" alt="' + esc(it.product_title) + '" width="84" height="100" loading="lazy">' : '') + '</a>' +
      '<div><h3 class="af-cart-item__title"><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a></h3>' +
      (it.variant_title && it.variant_title !== 'Default Title' ? '<div class="af-cart-item__meta">' + esc(it.variant_title) + '</div>' : '') +
      (it.properties && it.properties['Gift note'] ? '<div class="af-cart-item__meta">Gift note: ' + esc(it.properties['Gift note']) + '</div>' : '') +
      '<div class="af-price" style="margin-top:6px"><span>' + AF.money(it.final_line_price) + '</span>' + compare + '</div>' +
      '<div class="af-cart-item__row"><div class="af-qty af-qty--sm"><button type="button" data-af-line="' + (i+1) + '" data-q="' + (it.quantity - 1) + '" aria-label="Decrease quantity">−</button><input type="number" value="' + it.quantity + '" min="0" aria-label="Quantity" data-af-line-input="' + (i+1) + '"><button type="button" data-af-line="' + (i+1) + '" data-q="' + (it.quantity + 1) + '" aria-label="Increase quantity">+</button></div>' +
      '<button type="button" class="af-cart-item__remove" data-af-line="' + (i+1) + '" data-q="0">Remove</button></div></div></div>';
  }).join('');
  if(foot){ foot.hidden = false; var tot = $('[data-af-cart-total]', foot); if(tot) tot.textContent = AF.money(cart.total_price); }
};
AF.refreshCart = function(open){
  return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function(r){ return r.json(); }).then(function(cart){
    AF.renderCart(cart);
    if(open){ if(AF.cfg().drawer && $('#af-cart-drawer')) AF.open('af-cart-drawer'); else window.location.href = root + 'cart'; }
    return cart;
  });
};
AF.add = function(items, btn){
  if(btn){ btn.classList.add('is-loading'); btn._label = btn._label || btn.innerHTML; btn.innerHTML = 'Adding…'; }
  return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
    .then(function(r){ return r.json().then(function(d){ if(!r.ok) throw d; return d; }); })
    .then(function(){ document.dispatchEvent(new CustomEvent('af:cart:added')); return AF.refreshCart(true); })
    .catch(function(err){ AF.toast((err && (err.description || err.message)) || 'Sorry, this item could not be added.'); })
    .finally(function(){ if(btn){ btn.classList.remove('is-loading'); btn.innerHTML = btn._label; } });
};
AF.changeLine = function(line, qty){
  var body = $('#af-cart-body'); if(body) body.style.opacity = '.5';
  return fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: line, quantity: Math.max(0, qty) }) })
    .then(function(r){ return r.json(); }).then(function(cart){ if(cart.status && cart.description){ AF.toast(cart.description); return AF.refreshCart(); } AF.renderCart(cart); })
    .finally(function(){ if(body) body.style.opacity = ''; });
};
document.addEventListener('click', function(e){
  var b = e.target.closest('[data-af-line]');
  if(b){ e.preventDefault(); AF.changeLine(parseInt(b.getAttribute('data-af-line'),10), parseInt(b.getAttribute('data-q'),10)); return; }
  var q = e.target.closest('[data-af-quick-add]');
  if(q){ e.preventDefault(); AF.add([{ id: parseInt(q.getAttribute('data-af-quick-add'),10), quantity: 1 }], q); }
});
document.addEventListener('change', function(e){
  var i = e.target.closest('[data-af-line-input]');
  if(i) AF.changeLine(parseInt(i.getAttribute('data-af-line-input'),10), parseInt(i.value,10) || 0);
});
document.addEventListener('submit', function(e){
  var f = e.target.closest('form[data-af-atc]');
  if(!f) return;
  var submitter = e.submitter;
  if(submitter && submitter.name === 'checkout') return;
  e.preventDefault();
  var fd = new FormData(f), id = parseInt(fd.get('id'),10), qty = parseInt(fd.get('quantity'),10) || 1, props = {};
  fd.forEach(function(v, k){ var m = k.match(/^properties\[(.+)\]$/); if(m && v) props[m[1]] = v; });
  var item = { id: id, quantity: qty }; if(Object.keys(props).length) item.properties = props;
  AF.add([item], f.querySelector('[type=submit]'));
});

/* ---------- qty steppers ---------- */
document.addEventListener('click', function(e){
  var s = e.target.closest('[data-af-step]'); if(!s) return;
  var input = s.parentNode.querySelector('input'); if(!input) return;
  var v = (parseInt(input.value,10) || 1) + parseInt(s.getAttribute('data-af-step'),10);
  input.value = Math.max(parseInt(input.min || 1,10), v);
  input.dispatchEvent(new Event('change', { bubbles: true }));
});

/* ---------- predictive search ---------- */
function initSearch(){
  var input = $('#af-search-input'), out = $('#af-search-results'); if(!input || !out) return;
  var t, ctrl;
  input.addEventListener('input', function(){
    clearTimeout(t); var q = input.value.trim();
    if(q.length < 2){ out.innerHTML = ''; return; }
    t = setTimeout(function(){
      if(ctrl) ctrl.abort(); ctrl = window.AbortController ? new AbortController() : null;
      fetch(root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8', ctrl ? { signal: ctrl.signal } : {})
        .then(function(r){ return r.json(); }).then(function(d){
          var ps = (d.resources && d.resources.results && d.resources.results.products) || [];
          if(!ps.length){ out.innerHTML = '<p class="af-search__hint">No bags found for “' + esc(q) + '”.</p>'; return; }
          out.innerHTML = '<div class="af-search__results">' + ps.map(function(p){
            return '<article class="af-card"><a class="af-card__media" href="' + esc(p.url) + '">' + (p.image ? '<img src="' + esc(imgUrl(p.image, 400)) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a><div class="af-card__body"><h3 class="af-card__title"><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></h3><div class="af-price">' + AF.money(Math.round(parseFloat(p.price) * 100)) + '</div></div></article>';
          }).join('') + '</div><p style="text-align:center;padding-bottom:30px"><a class="af-link" href="' + root + 'search?q=' + encodeURIComponent(q) + '&type=product">View all results</a></p>';
        }).catch(function(){});
    }, 220);
  });
}

/* ---------- hero slideshow ---------- */
function initHero(el){
  var slides = $$('.af-hero__slide', el); if(slides.length < 2) return;
  var dots = $$('.af-hero__dots button', el), cur = $('[data-af-cur]', el), i = 0, timer, delay = parseInt(el.getAttribute('data-autoplay'),10) || 0;
  function go(n){
    slides[i].classList.remove('is-active'); slides[i].setAttribute('aria-hidden','true'); if(dots[i]) { dots[i].classList.remove('is-active'); dots[i].setAttribute('aria-current','false'); }
    i = (n + slides.length) % slides.length;
    slides[i].classList.add('is-active'); slides[i].setAttribute('aria-hidden','false'); if(dots[i]) { dots[i].classList.add('is-active'); dots[i].setAttribute('aria-current','true'); }
    if(cur) cur.textContent = ('0' + (i + 1)).slice(-2);
    restart();
  }
  function restart(){ clearInterval(timer); if(delay && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) timer = setInterval(function(){ go(i + 1); }, delay * 1000); }
  el.addEventListener('click', function(e){
    if(e.target.closest('[data-af-prev]')) go(i - 1);
    else if(e.target.closest('[data-af-next]')) go(i + 1);
    else { var d = e.target.closest('[data-af-go]'); if(d) go(parseInt(d.getAttribute('data-af-go'),10)); }
  });
  el.addEventListener('mouseenter', function(){ clearInterval(timer); });
  el.addEventListener('mouseleave', restart);
  var sx = null;
  el.addEventListener('touchstart', function(e){ sx = e.touches[0].clientX; }, { passive: true });
  el.addEventListener('touchend', function(e){ if(sx === null) return; var dx = e.changedTouches[0].clientX - sx; if(Math.abs(dx) > 50) go(i + (dx < 0 ? 1 : -1)); sx = null; });
  restart();
}

/* ---------- carousels ---------- */
function initCarousel(el){
  var track = $('.af-track', el); if(!track) return;
  var bar = $('.af-scrollbar span', el);
  function step(){ var c = track.firstElementChild; return c ? c.getBoundingClientRect().width + 24 : track.clientWidth; }
  el.addEventListener('click', function(e){
    if(e.target.closest('[data-af-prev]')) track.scrollBy({ left: -step(), behavior: 'smooth' });
    if(e.target.closest('[data-af-next]')) track.scrollBy({ left: step(), behavior: 'smooth' });
  });
  function upd(){ if(!bar) return; var max = track.scrollWidth - track.clientWidth; var w = Math.max(12, track.clientWidth / track.scrollWidth * 100); bar.style.width = w + '%'; bar.style.left = (max > 0 ? track.scrollLeft / max * (100 - w) : 0) + '%'; bar.parentNode.style.display = max > 4 ? '' : 'none'; }
  track.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
}

/* ---------- tabs ---------- */
function initTabs(el){
  var tabs = $$('[role=tab]', el);
  tabs.forEach(function(t, idx){
    t.addEventListener('click', function(){ select(idx); });
    t.addEventListener('keydown', function(e){ if(e.key === 'ArrowRight' || e.key === 'ArrowLeft'){ var n = (idx + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length; select(n); tabs[n].focus(); } });
  });
  function select(n){ tabs.forEach(function(t, k){ t.setAttribute('aria-selected', k === n ? 'true' : 'false'); t.tabIndex = k === n ? 0 : -1; var p = document.getElementById(t.getAttribute('aria-controls')); if(p) p.hidden = k !== n; }); $$('.af-track', el).forEach(function(tr){ tr.dispatchEvent(new Event('scroll')); }); }
}

/* ---------- countdown ---------- */
function initCountdown(el){
  var end = Date.parse(el.getAttribute('data-af-countdown')); if(isNaN(end)) { el.hidden = true; return; }
  var parts = { d: $('[data-d]', el), h: $('[data-h]', el), m: $('[data-m]', el), s: $('[data-s]', el) };
  function pad(n){ return ('0' + n).slice(-2); }
  function tick(){
    var diff = Math.max(0, end - Date.now());
    if(diff <= 0){ var wrap = el.closest('[data-af-countdown-wrap]') || el; wrap.hidden = true; clearInterval(iv); return; }
    var s = Math.floor(diff / 1000), d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), sec = s % 60;
    if(parts.d) parts.d.textContent = pad(d); else h += d * 24;
    if(parts.h) parts.h.textContent = pad(h); if(parts.m) parts.m.textContent = pad(m); if(parts.s) parts.s.textContent = pad(sec);
  }
  var iv = setInterval(tick, 1000); tick();
}

/* ---------- reveal ---------- */
function initReveal(){
  var els = $$('.af-reveal'); if(!els.length) return;
  if(!('IntersectionObserver' in window)){ els.forEach(function(e){ e.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function(en){ en.forEach(function(x){ if(x.isIntersecting){ x.target.classList.add('is-in'); io.unobserve(x.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
  els.forEach(function(e){ io.observe(e); });
}

/* ---------- product page ---------- */
function initProduct(el){
  var dataEl = $('[data-af-product-json]', el); if(!dataEl) return;
  var product = JSON.parse(dataEl.textContent), form = $('form[data-af-atc]', el), idInput = form && form.querySelector('[name=id]');
  var priceEl = $('[data-af-price]', el), saveEl = $('[data-af-save]', el), stockEl = $('[data-af-stock]', el), atc = $('[data-af-atc-btn]', el), buyNow = $('[data-af-buynow]', el);
  var sticky = $('.af-sticky-atc'), stickyPrice = sticky && $('[data-af-sticky-price]', sticky), stickyBtn = sticky && $('[data-af-sticky-btn]', sticky);
  function current(){
    var sel = $$('[data-af-option]', el).map(function(fs){ var c = fs.querySelector('input:checked'); return c ? c.value : null; });
    return product.variants.filter(function(v){ return v.options.every(function(o, i){ return sel[i] === null || o === sel[i]; }); })[0];
  }
  function update(){
    var v = current();
    $$('[data-af-option]', el).forEach(function(fs, idx){ var c = fs.querySelector('input:checked'), lbl = fs.querySelector('legend span'); if(c && lbl) lbl.textContent = c.value; });
    if(!v){ if(atc){ atc.disabled = true; atc.textContent = 'Unavailable'; } return; }
    if(idInput) idInput.value = v.id;
    if(priceEl){ priceEl.innerHTML = AF.money(v.price) + (v.compare_at_price > v.price ? '<s>' + AF.money(v.compare_at_price) + '</s>' : ''); }
    if(saveEl){ if(v.compare_at_price > v.price){ saveEl.hidden = false; saveEl.textContent = 'Save ' + Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100) + '%'; } else saveEl.hidden = true; }
    if(atc){ atc.disabled = !v.available; atc.textContent = v.available ? (atc.getAttribute('data-label') || 'Add to bag') : 'Sold out'; }
    if(buyNow) buyNow.hidden = !v.available;
    if(stickyPrice) stickyPrice.textContent = AF.money(v.price);
    if(stickyBtn){ stickyBtn.disabled = !v.available; stickyBtn.textContent = v.available ? 'Add to bag' : 'Sold out'; }
    if(stockEl){ var inv = stockEl.getAttribute('data-inv-' + v.id); stockEl.className = 'af-stock' + (!v.available ? ' af-stock--out' : (inv && parseInt(inv,10) > 0 && parseInt(inv,10) <= 5 ? ' af-stock--low' : '')); stockEl.textContent = !v.available ? 'Currently sold out' : (inv && parseInt(inv,10) > 0 && parseInt(inv,10) <= 5 ? 'Only ' + inv + ' left — order soon' : 'In stock, ready to ship'); }
    if(v.featured_media){ var slide = el.querySelector('[data-media-id="' + v.featured_media.id + '"]'); if(slide){ var m = slide.parentNode; if(window.innerWidth < 990) m.scrollTo({ left: slide.offsetLeft - 16, behavior: 'smooth' }); } }
    if(window.history.replaceState && el.hasAttribute('data-af-main')){ var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString()); }
    // availability hinting
    $$('[data-af-option]', el).forEach(function(fs, idx){
      $$('input', fs).forEach(function(inp){
        var others = $$('[data-af-option]', el).map(function(f2){ var c = f2.querySelector('input:checked'); return c ? c.value : null; });
        others[idx] = inp.value;
        var ok = product.variants.some(function(pv){ return pv.available && pv.options.every(function(o, i){ return o === others[i]; }); });
        var l = fs.querySelector('label[for="' + inp.id + '"]'); if(l) l.classList.toggle('is-unavailable', !ok);
      });
    });
  }
  el.addEventListener('change', function(e){ if(e.target.closest('[data-af-option]')) update(); });
  if(buyNow) buyNow.addEventListener('click', function(e){
    e.preventDefault(); var fd = new FormData(form);
    buyNow.classList.add('is-loading');
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(fd.get('id'),10), quantity: parseInt(fd.get('quantity'),10) || 1 }] }) })
      .then(function(r){ if(!r.ok) throw 0; window.location.href = root + 'checkout'; }).catch(function(){ buyNow.classList.remove('is-loading'); AF.toast('Sorry, this item could not be added.'); });
  });
  var gift = $('[data-af-gift]', el);
  if(gift){ gift.addEventListener('change', function(){ var ta = $('[data-af-gift-note]', el); if(ta){ ta.hidden = !gift.checked; ta.disabled = !gift.checked; if(gift.checked) ta.focus(); } }); }
  // mobile dots
  var media = $('.af-pdp__media', el), dots = $$('.af-pdp__thumbs span', el);
  if(media && dots.length){ media.addEventListener('scroll', function(){ var w = media.firstElementChild ? media.firstElementChild.getBoundingClientRect().width + 10 : 1; var n = Math.round(media.scrollLeft / w); dots.forEach(function(d, k){ d.classList.toggle('is-active', k === n); }); }, { passive: true }); }
  // lightbox
  var lb = $('.af-lightbox', el), slides = $$('.af-pdp__slide', el), li = 0;
  function show(n){ li = (n + slides.length) % slides.length; var img = slides[li].querySelector('img'); if(img && lb){ lb.querySelector('img').src = img.getAttribute('data-zoom') || img.src; lb.querySelector('img').alt = img.alt; } }
  slides.forEach(function(s, k){ s.addEventListener('click', function(){ if(!lb) return; show(k); lb.classList.add('is-open'); lb.querySelector('.af-close').focus(); }); });
  if(lb){ lb.addEventListener('click', function(e){ if(e.target.closest('[data-af-lb-prev]')) show(li - 1); else if(e.target.closest('[data-af-lb-next]')) show(li + 1); else if(e.target.closest('.af-close') || e.target === lb) lb.classList.remove('is-open'); }); }
  // share
  var share = $('[data-af-share]', el);
  if(share) share.addEventListener('click', function(){ var url = window.location.href; if(navigator.share){ navigator.share({ title: document.title, url: url }).catch(function(){}); } else if(navigator.clipboard){ navigator.clipboard.writeText(url).then(function(){ AF.toast('Link copied'); }); } });
  // sticky
  if(sticky && atc && 'IntersectionObserver' in window){
    new IntersectionObserver(function(en){ en.forEach(function(x){ sticky.classList.toggle('is-visible', !x.isIntersecting && x.boundingClientRect.top < 0); }); }).observe(atc);
    if(stickyBtn) stickyBtn.addEventListener('click', function(){ if(form.requestSubmit) form.requestSubmit(atc); else atc.click(); });
  }
  update();
}

/* ---------- bundle ---------- */
function initBundle(el){
  var items = $$('.af-bitem', el), totalEl = $('[data-af-bundle-total]', el), btn = $('[data-af-bundle-add]', el), list = $$('[data-af-bundle-line]', el);
  function calc(){
    var sum = 0, cmp = 0, n = 0;
    items.forEach(function(it, k){ var on = it.querySelector('input').checked; it.classList.toggle('is-selected', on); if(list[k]) list[k].classList.toggle('is-off', !on); if(on){ sum += parseInt(it.getAttribute('data-price'),10); cmp += parseInt(it.getAttribute('data-compare'),10); n++; } });
    if(totalEl) totalEl.innerHTML = (cmp > sum ? '<s>' + AF.money(cmp) + '</s>' : '') + AF.money(sum);
    if(btn){ btn.disabled = !n; btn.textContent = 'Add ' + n + ' item' + (n === 1 ? '' : 's') + ' to bag'; btn._label = null; }
  }
  el.addEventListener('change', calc);
  if(btn) btn.addEventListener('click', function(){
    var sel = items.filter(function(it){ return it.querySelector('input').checked; }).map(function(it){ return { id: parseInt(it.getAttribute('data-variant'),10), quantity: 1 }; });
    if(sel.length) AF.add(sel, btn).then(calc);
  });
  calc();
}

/* ---------- collection filters ---------- */
function initFacets(el){
  var form = $('form[data-af-facets]', el);
  if(form){
    form.addEventListener('change', function(e){ if(e.target.type === 'number') return; submit(); });
    form.addEventListener('submit', function(e){ e.preventDefault(); submit(); });
  }
  function submit(){ var params = new URLSearchParams(new FormData(form)); var out = new URLSearchParams(); params.forEach(function(v, k){ if(v !== '') out.append(k, v); }); window.location.search = out.toString(); }
  var sort = $('[data-af-sort]', el);
  if(sort) sort.addEventListener('change', function(){ var u = new URL(window.location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); window.location.href = u.toString(); });
  $$('[data-af-cols]', el).forEach(function(b){ b.addEventListener('click', function(){ var g = $('.af-grid', el); if(g) g.style.setProperty('--cols', b.getAttribute('data-af-cols')); $$('[data-af-cols]', el).forEach(function(x){ x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); }); try{ localStorage.setItem('af-cols', b.getAttribute('data-af-cols')); }catch(err){} }); });
  try{ var saved = localStorage.getItem('af-cols'); if(saved){ var sb = $('[data-af-cols="' + saved + '"]', el); if(sb) sb.click(); } }catch(err){}
}

/* ---------- header ---------- */
function initHeader(){
  var h = $('.af-header'); if(!h) return;
  var on = false;
  window.addEventListener('scroll', function(){ var s = window.scrollY > 10; if(s !== on){ on = s; h.classList.toggle('is-scrolled', s); } }, { passive: true });
}

/* ---------- boot ---------- */
function boot(scope){
  scope = scope || document;
  $$('[data-af-hero]', scope).forEach(initHero);
  $$('[data-af-carousel]', scope).forEach(initCarousel);
  $$('[data-af-tabs]', scope).forEach(initTabs);
  $$('[data-af-countdown]', scope).forEach(initCountdown);
  $$('[data-af-product]', scope).forEach(initProduct);
  $$('[data-af-bundle]', scope).forEach(initBundle);
  $$('[data-af-collection]', scope).forEach(initFacets);
  initReveal();
}
function start(){ getOverlay(); initHeader(); initSearch(); boot(document); }
if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
document.addEventListener('shopify:section:load', function(e){ boot(e.target); initSearch(); });
window.addEventListener('pageshow', function(e){ if(e.persisted) AF.refreshCart(false); });
})();
